import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span>⚡</span>
              <span>Algo<span style={{ color: 'var(--accent-bright)' }}>Solve</span></span>
            </div>
            <p className="footer-tagline">
              Master OS algorithms through interactive learning, dry runs, and hands-on problem solving.
            </p>
          </div>

          <div className="footer-col">
            <h4>Learn</h4>
            <Link to="/algorithms">All Algorithms</Link>
            <Link to="/categories">By Category</Link>
            <Link to="/compare">Compare Algorithms</Link>
          </div>

          <div className="footer-col">
            <h4>Practice</h4>
            <Link to="/problems">All Problems</Link>
            <Link to="/problems?difficulty=Easy">Easy Problems</Link>
            <Link to="/problems?difficulty=Hard">Hard Problems</Link>
          </div>

          <div className="footer-col">
            <h4>Topics</h4>
            <Link to="/categories">Process Scheduling</Link>
            <Link to="/categories">Memory Management</Link>
            <Link to="/categories">Disk Scheduling</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} AlgoSolve. Built for OS learners everywhere.</p>
          <p className="footer-tech">React · Node.js · No Auth Required</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
